import m from "./index.es7.js";
import p from "./index.es18.js";
function f(e, {
  decodeEntities: o = !0,
  transform: t,
  preprocessNodes: s = (r) => r
} = {}) {
  const r = s(m.parseDOM(e, { decodeEntities: o }));
  return p(r, t);
}
export {
  f as default
};
//# sourceMappingURL=index.es5.js.map
